define([
    'text!product-detail/gallery/knowledge-info.html',
    'product-detail/component/knowledge-tabs',
    'product-detail/mixin/product',
    'lodash',

    'css!product-detail/gallery/knowledge-info.css'
], function(
    tpl,
    KnowledgeTabs,
    ProductMixin,
    _
){
    var tabs = [
        {title:'关于支付',subtitle:'Pay For',icon:'u-icon-money',field:'aboutPayGal'},
        {title:'关于售后',subtitle:'Customer Service',icon:'u-icon-talk',field:'aboutServiceGal'},
        {title:'关于运送',subtitle:'Delivery',icon:'u-icon-truck2',field:'aboutDeliveryGal'}
    ];

    return {
        template: tpl,
        mixins: [ProductMixin],
        components: {
            KnowledgeTabs: KnowledgeTabs
        },
        props: {
            isSkuYmb: {
                type: Boolean,
                default:false
            }
        },
        data: function(){
            return {
                tabs: tabs
            };
        },
        methods: {
            initTabs: function(){
                if(this.isSkuYmb)
                    this.tabs = [
                        {title:'关于运送',subtitle:'Delivery',icon:'u-icon-truck2',field:'artDeliveryYMB'}
                    ];
                var spuBase = this.spuBase;
                _.forEach(this.tabs, function(o){
                    o.desc = spuBase[o.field];
                });
            }
        },
        created: function(){
            this.initTabs();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/gallery/knowledge-info.js
// module id = 322
// module chunks = 0